import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { LOGO } from "@/data/site";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!loading && user?.role === "admin") navigate("/admin"); }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      if (u.role === "admin") navigate("/admin");
      else setErr("This account is not an admin.");
    } catch (e2) { setErr("Invalid email or password"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[75vh] flex items-center justify-center px-4 pt-10">
      <Seo title="Admin Login" description="Rossi Ceramics admin login." />
      <form onSubmit={submit} className="card-lux p-8 w-full max-w-sm" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-6">
          <img src={LOGO} alt="Rossi Ceramics" className="h-14 w-14 object-contain rounded-lg bg-white p-1.5 mb-3" />
          <h1 className="font-serif text-2xl text-rossi-cream flex items-center gap-2"><Lock size={18} className="text-rossi-gold" /> Admin</h1>
          <p className="text-xs text-rossi-stone mt-1">Rossi Ceramics CRM</p>
        </div>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream mb-3 focus:outline-none focus:border-rossi-gold/50" data-testid="admin-email" />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-rossi-bg border border-white/10 rounded-lg px-3 py-2.5 text-sm text-rossi-cream mb-3 focus:outline-none focus:border-rossi-gold/50" data-testid="admin-password" />
        {err && <p className="text-sm text-red-400 mb-3" data-testid="admin-error">{err}</p>}
        <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="admin-login-submit">{busy ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}</button>
      </form>
    </div>
  );
}
